/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */

import React, { useState } from "react";
import { isOnline, sweetAlert } from "functions/global";
import "./styles.css";

import GoogleScopeLogin from "components/GoogleScopeLogin";
import { updatePlatforms } from "functions/googleAds";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { IS_GOOGLE_DISABLED } from "constants/global/flags";
import FbPages from "./fbPages";
import PlatformAvatar from "components/PlatformAvatar";
import {
  getPlatformConnectionUi,
  getProfileImageFromDetails,
} from "constants/platforms/connectionUi";
import { GOOGLE_SOCIAL_SCOPES } from "constants/googleAds";

const SocialAdsAccountSelection = (props: any) => {
  const {
    type,
    state,
    loader,
    connect,
    switchAccount,
    isConnectLoading,
    adsAccountDetails = {},
    switchPropertyId,
    switchViewId,
    propertyLoader,
    viewIdLoader,
    googleAdAccountId,
    setGoogleAdAccountId,
    setIsGoogleAccManager,
    isGoogleAccManager,
    setIsAddAdAccModal,
    setIsShowSelectedAccIds,
    googleSelectedAdAccountList,
    switchSnapchatOrganization,
    organizationLoader,
    isExternalApi,
    onConnectionStart,
    onConnectionEnd,
    onConnectOpenAiAds,
    onProfileClick,
  } = props;

  const [bingAccountType, setBingAccountType] = useState<
    "personal" | "company" | "dual"
  >("personal");
  const [openAiApiKey, setOpenAiApiKey] = useState("");
  const [showOpenAiApiKey, setShowOpenAiApiKey] = useState(false);

  let {
    accountId,
    accountName,
    isConnected,
    refreshToken,
    apiKey,
    userName,
    propertyId,
    viewId,
    propertyName,
    viewName,
    organizationName,
    businessName,
    organizationId,
    businessId,
    channelName,
  } = adsAccountDetails;

  const platformUi = getPlatformConnectionUi(type);
  // Real profile photo when available; otherwise PlatformAvatar shows a
  // polished letter/placeholder avatar with the platform badge.
  const profileImageUrl =
    platformUi.supportsProfileImage || type === "OPENAI_ADS"
      ? getProfileImageFromDetails(adsAccountDetails, {
          allowLogoUrl: type === "OPENAI_ADS",
        })
      : "";

  const googleAdsScopes =
    "https://www.googleapis.com/auth/youtube.readonly https://www.googleapis.com/auth/yt-analytics-monetary.readonly https://www.googleapis.com/auth/analytics.manage.users https://www.googleapis.com/auth/analytics.readonly https://www.googleapis.com/auth/adwords https://www.googleapis.com/auth/youtube.upload https://www.googleapis.com/auth/youtube.force-ssl";

  const scopes =
    type === "GOOGLE_SOCIAL" ? GOOGLE_SOCIAL_SCOPES : googleAdsScopes;

  const platformName =
    type === "GOOGLE_SOCIAL"
      ? "googleSocial"
      : type === "GOOGLE_ADS_ANALYTICS" || type === "GOOGLE"
      ? "googleAdwords"
      : type === "YOUTUBE_ANALYTICS"
        ? "youtubeAnalytics"
        : "googleAnalytics";

  // Prefer YouTube channel name for social connection display
  if (type === "GOOGLE_SOCIAL") {
    accountName = channelName || accountName;
    userName = channelName || userName;
  }

  let splitProperty: any = [];
  if (propertyId) {
    splitProperty = propertyId.split("-");
  }

  let redirect_uri =
    process.env.NODE_ENV === "development"
      ? "http://localhost:3000/"
      : "https://app.advertgenerator.com/";

  // Treat token presence as connected — Meta/Facebook often has refreshToken
  // even when isConnected is missing or stale in Firestore.
  isConnected =
    type === "OPENAI_ADS"
      ? !!(isConnected && apiKey)
      : type === "TIKTOK" || type === "TIKTOK_SOCIAL"
        ? !!(refreshToken || accountId || adsAccountDetails?.accessToken)
        : type === "GOOGLE_SOCIAL"
          ? !!(refreshToken || channelName || adsAccountDetails?.isConnected)
        : !!(
            isConnected ||
            refreshToken ||
            adsAccountDetails?.accessToken ||
            accountId
          );

  const profileDisplayName =
    type === "TIKTOK" && isConnected
      ? "TikTok Ads"
      : type === "GOOGLE_SOCIAL" && isConnected
        ? channelName || userName || "YouTube"
      : type === "GOOGLE_ANALYTICS" && isConnected
        ? "Google Analytics"
        : userName || "Connected profile";

  const profileSubtitle = isConnected
    ? type === "GOOGLE_SOCIAL"
      ? "Connected YouTube channel"
      : "Connected profile"
    : `Connect your ${platformUi.networkName} profile`;

  const handleTikTokSocialConnect = () => {
    window.open(
      `https://www.tiktok.com/v2/auth/authorize/?client_key=${
        process.env.REACT_APP_TIKTOK_SOCIAL_CLIENT_KEY
      }&scope=user.info.basic,video.upload,video.publish,user.info.stats,video.list&response_type=code&redirect_uri=${redirect_uri}&state=${JSON.stringify(
        { ...state, Account: "TIKTOK_SOCIAL" },
      )}`,
      "_self",
    );
  };

  const openOAuth = (onClickActionText?: any) => {
    if (type === "SNAPCHAT") {
      window.open(
        `https://accounts.snapchat.com/login/oauth2/authorize?client_id=f4ab840f-784b-4589-9cef-262f11699192&state=${JSON.stringify(
          state,
        )}&redirect_uri=https://app.advertgenerator.com/&response_type=code&scope=snapchat-marketing-api%20snapchat-profile-api`,
        "_self",
      );
      return;
    }

    if (type === "LINKEDIN") {
      window.open(
        `https://www.linkedin.com/oauth/v2/authorization?response_type=code&client_id=86bqa8ga1qgt90&redirect_uri=${redirect_uri}&state=${JSON.stringify(
          state,
        )}&scope=r_marketing_leadgen_automation%2Cr_liteprofile%2Cr_events%2Cr_ads_leadgen_automation%2Cr_1st_connections_size%2Cr_ads%2Cr_ads_reporting%2Cr_basicprofile%2Cr_organization_admin%2Cr_organization_social%2Crw_ads%2Crw_organization_admin%2Cw_member_social%2Cw_organization_social%2Copenid%2Cprofile%2Cemail`,
        "_self",
      );
      return;
    }

    if (type === "BING_ADS") {
      window.open(
        `https://login.microsoftonline.com${
          bingAccountType === "personal"
            ? "/common"
            : bingAccountType === "dual"
              ? "/consumers"
              : "/organizations"
        }/oauth2/v2.0/authorize?client_id=e5153ce5-a687-4eea-a9ec-2067cb483c65&response_type=code&redirect_uri=https://app.advertgenerator.com/&response_mode=query&scope=openid%20offline_access%20https%3A%2F%2Fads.microsoft.com%2Fmsads.manage&state=${JSON.stringify(
          state,
        )}&sso_reload=true`,
        "_self",
      );
      return;
    }

    if (type === "SPOTIFY") {
      window.open(
        `https://accounts.spotify.com/authorize/?client_id=698dbc0c45ca469288c93ece575dc370&response_type=code&redirect_uri=https://app.advertgenerator.com/&state=${JSON.stringify(
          state,
        )}`,
        "_self",
      );
      return;
    }

    if (type === "TIKTOK") {
      window.open(
        `https://ads.tiktok.com/marketing_api/auth?app_id=6932899027516129282&state=${JSON.stringify(
          state,
        )}&redirect_uri=https://app.advertgenerator.com/`,
        "_self",
      );
      return;
    }

    if (type === "TIKTOK_SOCIAL") {
      handleTikTokSocialConnect();
      return;
    }

    if (onClickActionText) {
      onClickActionText();
    }
  };

  const renderSelectionCard = ({
    title,
    subtitle,
    onClick,
    leading,
    status,
    disabled,
    showViewPermissions,
  }: {
    title: string;
    subtitle: string;
    onClick?: () => void;
    leading: React.ReactNode;
    status?: React.ReactNode;
    disabled?: boolean;
    showViewPermissions?: boolean;
  }) => (
    <button
      type="button"
      className={`platform-selection-card ${
        disabled ? "platform-selection-card--disabled" : ""
      }`}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
    >
      <div className="platform-selection-card__leading">{leading}</div>
      <div className="platform-selection-card__content">
        <p className="platform-selection-card__title">{title}</p>
        <p className="platform-selection-card__subtitle">{subtitle}</p>
        {status}
      </div>
      <div className="platform-selection-card__trailing">
        {showViewPermissions ? (
          <span className="platform-selection-card__view-permissions">
            View permissions
          </span>
        ) : null}
        <span className="platform-selection-card__chevron" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" aria-hidden="true">
            <path
              d="M9 6L15 12L9 18"
              stroke="currentColor"
              strokeWidth="2.2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </div>
    </button>
  );

  const renderSecurityNote = () => (
    <div className="platform-security-note">
      <span className="platform-security-note__icon" aria-hidden="true">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
          <path
            d="M7 10V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10M6 10H18C18.5523 10 19 10.4477 19 11V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V11C5 10.4477 5.44772 10 6 10Z"
            stroke="currentColor"
            strokeWidth="1.8"
            strokeLinecap="round"
          />
        </svg>
      </span>
      <p>{platformUi.securityText}</p>
    </div>
  );

  const renderAdAccountSection = () => {
    if (type === "TIKTOK_SOCIAL" || type === "GOOGLE_SOCIAL") {
      return null;
    }

    if (type === "GOOGLE" && IS_GOOGLE_DISABLED) {
      if (!googleSelectedAdAccountList?.length) {
        return (
          <button
            type="button"
            className="platform-primary-btn"
            onClick={() => setIsAddAdAccModal(true)}
          >
            Add new Ad Accounts
          </button>
        );
      }

      return (
        <div className="google-ad-account-input-container">
          <p className="google-ad-account-input-label">ENTER AD ACCOUNT ID</p>
          <div className="platform-inline-field">
            <input
              className="platform-text-input"
              placeholder="Example: 111-000-1234"
              value={googleAdAccountId}
              onChange={(e: any) => {
                if (e.target.value.length === 3) {
                  const text = e.target.value.substring(0, 3) + "-";
                  setGoogleAdAccountId(text);
                } else if (e.target.value.length === 7) {
                  const text = e.target.value.substring(0, 7) + "-";
                  setGoogleAdAccountId(text);
                } else {
                  setGoogleAdAccountId(e.target.value);
                }
              }}
              onKeyUp={(e: any) => {
                if (e.key === "Backspace") {
                  if (e.target.value.length === 4) {
                    setGoogleAdAccountId(e.target.value.substring(0, 3));
                  } else if (e.target.value.length === 8) {
                    setGoogleAdAccountId(e.target.value.substring(0, 7));
                  }
                }
              }}
              maxLength={12}
            />
            <button
              type="button"
              className="platform-link-btn"
              onClick={() => {
                if (googleSelectedAdAccountList.length) {
                  setIsShowSelectedAccIds(true);
                } else {
                  sweetAlert(
                    `You don't have added google Ad accounts. Please add new ad account.`,
                  );
                }
              }}
            >
              Select
            </button>
          </div>
          <p
            className="google-disable-ad-acc-text"
            onClick={() => setIsAddAdAccModal(true)}
          >
            Add new ad account
          </p>
          <div className="google-disable-manager-radio-btn">
            <p className="google-disable-manager-radio-btn-heading">
              Are you the Google Ad Account Admin?
            </p>
            {["Yes", "No"].map((name) => (
              <div
                key={name}
                onClick={() => setIsGoogleAccManager(name)}
                className="google-disable-radio-btn-container"
              >
                <p className="google-disable-radio-btn-text">{name}</p>
                {name === isGoogleAccManager ? (
                  <img
                    alt=""
                    src="images/global/check.png"
                    className="google-disable-radio-btn"
                  />
                ) : (
                  <div className="google-disable-radio-btn-unchecked" />
                )}
              </div>
            ))}
          </div>
        </div>
      );
    }

    if ((type === "SPOTIFY" || type === "SNAPCHAT") && isConnected) {
      return (
        <>
          {renderSelectionCard({
            title:
              type === "SPOTIFY" ? "Select business" : "Select organization",
            subtitle:
              organizationName ||
              businessName ||
              (type === "SPOTIFY"
                ? "Choose a business to continue."
                : "Choose an organization to continue."),
            onClick: switchSnapchatOrganization,
            leading: (
              <div className="platform-briefcase-icon" aria-hidden="true">
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M9 7V6C9 4.89543 9.89543 4 11 4H13C14.1046 4 15 4.89543 15 6V7M4 9H20V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V9Z"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            ),
            status: organizationLoader ? (
              <p className="platform-selection-card__meta">Loading...</p>
            ) : null,
          })}

          {(organizationId || businessId) &&
            renderSelectionCard({
              title: accountId
                ? accountName || "Ad account"
                : platformUi.adAccountOptional
                  ? "Ad account (optional)"
                  : "Select your ad account",
              subtitle: accountId
                ? "Ad Account"
                : platformUi.adAccountOptional
                  ? "No ad account selected"
                  : "Choose an ad account to continue.",
              onClick: switchAccount,
              leading: (
                <div className="platform-briefcase-icon" aria-hidden="true">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M9 7V6C9 4.89543 9.89543 4 11 4H13C14.1046 4 15 4.89543 15 6V7M4 9H20V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V9Z"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
              ),
              status: loader ? (
                <p className="platform-selection-card__meta">Loading...</p>
              ) : accountId ? (
                <div className="platform-status-row">
                  <span className="platform-status-dot platform-status-dot--active" />
                  <span>Active</span>
                </div>
              ) : null,
            })}
        </>
      );
    }

    if (!isConnected) {
      return null;
    }

    return (
      <>
        {renderSelectionCard({
          title: accountId
            ? accountName || "Ad account"
            : platformUi.adAccountOptional
              ? "Ad account (optional)"
              : "Select your ad account",
          subtitle: accountId
            ? "Ad Account"
            : platformUi.adAccountOptional
              ? "Connect an ad account if you plan to advertise."
              : "Choose an ad account to continue.",
          onClick: switchAccount,
          leading: (
            <div className="platform-briefcase-icon" aria-hidden="true">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                <path
                  d="M9 7V6C9 4.89543 9.89543 4 11 4H13C14.1046 4 15 4.89543 15 6V7M4 9H20V18C20 19.1046 19.1046 20 18 20H6C4.89543 20 4 19.1046 4 18V9Z"
                  stroke="currentColor"
                  strokeWidth="1.8"
                  strokeLinecap="round"
                />
              </svg>
            </div>
          ),
          status: loader ? (
            <p className="platform-selection-card__meta">Loading...</p>
          ) : accountId ? (
            <div className="platform-status-row">
              <span className="platform-status-dot platform-status-dot--active" />
              <span>Active</span>
            </div>
          ) : null,
        })}

        {!!accountId && type === "GOOGLE_ANALYTICS" && (
          <>
            {renderSelectionCard({
              title: propertyName || "Select property",
              subtitle: propertyId ? "Property" : "Choose a property",
              onClick: switchPropertyId,
              leading: (
                <div className="platform-briefcase-icon" aria-hidden="true">
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                    <path
                      d="M4 7H20M4 12H20M4 17H14"
                      stroke="currentColor"
                      strokeWidth="1.8"
                      strokeLinecap="round"
                    />
                  </svg>
                </div>
              ),
              status: propertyLoader ? (
                <p className="platform-selection-card__meta">Loading...</p>
              ) : null,
            })}

            {propertyId &&
              splitProperty[0] === "UA" &&
              renderSelectionCard({
                title: viewName || "Select view",
                subtitle: viewId ? "View" : "Choose a view",
                onClick: switchViewId,
                leading: (
                  <div className="platform-briefcase-icon" aria-hidden="true">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="none">
                      <path
                        d="M4 7H20M4 12H20M4 17H14"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                      />
                    </svg>
                  </div>
                ),
                status: viewIdLoader ? (
                  <p className="platform-selection-card__meta">Loading...</p>
                ) : null,
              })}
          </>
        )}
      </>
    );
  };

  const _renderSocialAdsAccountSelection = (onClickActionText?: any) => {
    return (
      <div className="social-ads-acc-selection-container">
        {type === "BING_ADS" && !isConnected && (
          <div className="bing-account-type-selector">
            <p className="m-0 mb-2 social-ads-acc-selection-heading">
              Account type
            </p>
            <div className="bing-account-type-options">
              {(
                [
                  ["personal", "Personal account"],
                  ["company", "Company account"],
                  ["dual", "Dual account"],
                ] as const
              ).map(([value, label]) => (
                <label
                  key={value}
                  className={`bing-account-type-option ${
                    bingAccountType === value
                      ? "bing-account-type-option--selected"
                      : ""
                  }`}
                >
                  <input
                    type="radio"
                    name="bingAccountType"
                    value={value}
                    checked={bingAccountType === value}
                    onChange={() => setBingAccountType(value)}
                  />
                  <span>{label}</span>
                </label>
              ))}
            </div>
          </div>
        )}

        {!isConnected ? (
          <button
            type="button"
            className="platform-connect-btn"
            onClick={() => openOAuth(onClickActionText)}
            disabled={!!isConnectLoading}
          >
            {type === "FACEBOOK" || type === "INSTAGRAM" ? (
              <svg
                className="platform-connect-btn__meta-icon"
                viewBox="0 0 28 28"
                aria-hidden="true"
              >
                <circle cx="14" cy="14" r="14" fill="#ffffff" />
                <path
                  d="M16.1 27.6V16.9h3.6l.5-4.2h-4.1V10c0-1.2.3-2 2.1-2h2.2V4.3c-.4-.1-1.7-.2-3.2-.2-3.2 0-5.4 2-5.4 5.6v3.1H8.2V17h3.6v10.6c.7.2 1.4.4 2.2.4.7 0 1.4-.1 2.1-.4Z"
                  fill="#1677ea"
                />
              </svg>
            ) : (
              <img src={platformUi.badgeLogo} alt="" />
            )}
            <span>
              {isConnectLoading ? "Connecting..." : platformUi.connectLabel}
            </span>
          </button>
        ) : (
          <div className="platform-selection-stack">
            {renderSelectionCard({
              title: profileDisplayName,
              subtitle: profileSubtitle,
              onClick: onProfileClick || (() => openOAuth(onClickActionText)),
              showViewPermissions: true,
              leading: (
                <PlatformAvatar
                  imageUrl={profileImageUrl}
                  name={profileDisplayName}
                  badgeLogo={platformUi.badgeLogo}
                />
              ),
              status: isConnectLoading ? (
                <p className="platform-selection-card__meta">Loading...</p>
              ) : null,
            })}
            {renderAdAccountSection()}
          </div>
        )}

        {renderSecurityNote()}
      </div>
    );
  };

  const handleGoogleAdwordsConnect = (renderProps: any) => {
    if (isOnline()) {
      renderProps.onClick();
    } else {
      sweetAlert(
        "Please make sure your device is connected to internet!",
        "error",
        null,
      );
    }
  };

  const _renderOpenAiAdsAccountSelection = () => {
    const handleSubmit = async () => {
      if (!openAiApiKey.trim()) {
        sweetAlert("Please enter your OpenAI Ads API key");
        return;
      }

      if (onConnectOpenAiAds) {
        await onConnectOpenAiAds(openAiApiKey.trim());
      }
    };

    return (
      <div className="openai-ads-connection">
        {!isConnected ? (
          <>
            <label className="openai-ads-api-key-label" htmlFor="openai-api-key">
              API key
            </label>
            <div className="openai-ads-api-key-field">
              <span className="openai-ads-api-key-icon" aria-hidden="true">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
                  <path
                    d="M7 10V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10M6 10H18C18.5523 10 19 10.4477 19 11V20C19 20.5523 18.5523 21 18 21H6C5.44772 21 5 20.5523 5 20V11C5 10.4477 5.44772 10 6 10Z"
                    stroke="currentColor"
                    strokeWidth="1.8"
                    strokeLinecap="round"
                  />
                </svg>
              </span>
              <input
                id="openai-api-key"
                className="openai-ads-api-key-input"
                type={showOpenAiApiKey ? "text" : "password"}
                placeholder="sk-••••••••••••••••••••••••••••••••"
                value={openAiApiKey}
                onChange={(e) => setOpenAiApiKey(e.target.value)}
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    handleSubmit();
                  }
                }}
              />
              <button
                type="button"
                className="openai-ads-api-key-toggle"
                onClick={() => setShowOpenAiApiKey((prev) => !prev)}
                aria-label={showOpenAiApiKey ? "Hide API key" : "Show API key"}
              >
                {showOpenAiApiKey ? "Hide" : "Show"}
              </button>
            </div>
            <p className="openai-ads-help-text">
              Don&apos;t have API key?{" "}
              <a
                href="https://ads.openai.com/settings"
                target="_blank"
                rel="noopener noreferrer"
                className="openai-ads-help-link"
              >
                Generate here
              </a>
            </p>
            <button
              type="button"
              className="platform-connect-btn"
              onClick={handleSubmit}
              disabled={isConnectLoading}
            >
              {isConnectLoading ? "Connecting..." : "Connect account"}
            </button>
          </>
        ) : (
          <div className="platform-selection-stack">
            {renderSelectionCard({
              title: accountName || userName || "ChatGPT Ads",
              subtitle: accountId
                ? `Account ID: ${accountId}`
                : "Connected account",
              onClick: connect,
              showViewPermissions: true,
              leading: (
                <PlatformAvatar
                  imageUrl={profileImageUrl}
                  name={accountName || userName || "ChatGPT Ads"}
                  badgeLogo={platformUi.badgeLogo}
                />
              ),
            })}
          </div>
        )}
        {renderSecurityNote()}
      </div>
    );
  };

  return (
    <div
      className={`ad-account-selection-container ${
        type === "OPENAI_ADS" ? "ad-account-selection-container--openai" : ""
      }`}
    >
      {type === "TIKTOK" ? (
        _renderSocialAdsAccountSelection(!isConnectLoading && connect)
      ) : type === "SNAPCHAT" ? (
        _renderSocialAdsAccountSelection(!isConnectLoading && connect)
      ) : type === "LINKEDIN" ? (
        _renderSocialAdsAccountSelection(!isConnectLoading && connect)
      ) : type === "BING_ADS" ? (
        _renderSocialAdsAccountSelection(!isConnectLoading && connect)
      ) : type === "SPOTIFY" ? (
        _renderSocialAdsAccountSelection(!isConnectLoading && connect)
      ) : type === "TIKTOK_SOCIAL" ? (
        _renderSocialAdsAccountSelection(!isConnectLoading && connect)
      ) : type === "OPENAI_ADS" ? (
        _renderOpenAiAdsAccountSelection()
      ) : type === "FACEBOOK" || type === "INSTAGRAM" ? (
        <>
          {_renderSocialAdsAccountSelection(!isConnectLoading && connect)}
          {isConnected && isExternalApi && (
            <FbPages accessToken={refreshToken} />
          )}
        </>
      ) : (
        <GoogleOAuthProvider clientId={process.env.REACT_APP_CLIENT_ID || ""}>
          <GoogleScopeLogin
            scope={scopes}
            onSuccess={async (response: any) => {
              if (onConnectionStart) onConnectionStart();
              try {
                await updatePlatforms(platformName, response);
              } catch (error) {
                console.error(error);
              } finally {
                if (onConnectionEnd) onConnectionEnd();
              }
            }}
            render={(renderProps: any) =>
              _renderSocialAdsAccountSelection(() =>
                handleGoogleAdwordsConnect(renderProps),
              )
            }
          />
        </GoogleOAuthProvider>
      )}
    </div>
  );
};

export default SocialAdsAccountSelection;
